<template>
  <div class="vx-row pb-3" v-show="isCardActiveLocal">
    <div class="vx-col w-full"> 
        <div class="w-full">
          <vx-card id="videosCard" ref="Video" title="Videos" v-show="!isVideoListHidden">        
            <div id="data-list-thumb-view" class="data-list-container listvideostable">
              <vs-table :sst="false" pagination :max-items="pageSize" search :data="videos" stripe ref="videoTable" class="vs-con-loading__container" single @selected="handleSelectedVideo"> <!-- @sort="handleSort" -->
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
                  <!-- ADD NEW -->
                  <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewVideo">
                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                    <span class="ml-2 text-base text-primary">Add New</span>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th></vs-th>
                  <vs-th>Title</vs-th>
                  <vs-th>Producer</vs-th>
                  <vs-th>Genre</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="video" :state="video.isActive == false ? 'warning':null" :key="indextr" v-for="(video, indextr) in data" >

                    <vs-td style="text-align: -webkit-center;text-align: -moz-center;">
                      <img :src="video.coverPageUrl" height=60px />
                    </vs-td>             
                    <vs-td>
                      {{ video.title}}
                    </vs-td>
                    <vs-td>
                      {{ video.producer }}
                    </vs-td>
                    <vs-td>
                      {{ video.genreName }}
                    </vs-td>
                    <vs-td>
                      <vs-chip v-show="video.isReadOnly" color="success">Inherited</vs-chip>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
        <div style="text-align:left">
          <vx-card title="Video Info" v-show="!isInfoHidden">
            <vs-divider class="mb-6 pt-0">Video Details</vs-divider>        
            <div class="vx-row pb-3">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Title</label>
                <vs-input :disabled="isReadOnly" autocomplete="off" onClick="this.select();" v-validate="'required'" name="Title" class="w-full" v-model="formData.title" />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Producer</label>
                <vs-input :disabled="isReadOnly" autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.producer" />
              </div>
            </div>
            <div v-if="!isReadOnly" class="vx-row pb-3">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Genre</label>
                <v-select ref="genreDropdown" placeholder="Select a Genre" :options="genres" v-validate="'required'" name="Genre" class="w-full" v-model="genreDropdown"></v-select>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Summary</label>
                <vs-textarea v-model="formData.summary" />            
              </div>
            </div>
            <div v-else class="vx-row pb-3">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Genre</label>
                <vs-input autocomplete="off" :disabled="true" class="w-full" v-model="formData.genreName" />
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <label>Summary</label>
                <vs-input autocomplete="off" :disabled="true" class="w-full" v-model="formData.summary" />            
              </div>
            </div>

            <vs-divider class="mb-6 pt-0">Tags</vs-divider>
            
              <div class="vx-row">
                <!-- <div class="centerx default-input vx-col">
                  <vs-input class="inputx" v-model="tagToAdd" />
                </div>
                
                <vs-button radius class="vx-col" color="success" type="filled" icon-pack="feather" icon="icon-plus" @click="addTag"></vs-button>  -->

                <vs-chips id="tags" class="vx-col w-full pt-2" color="rgb(145, 32, 159)" placeholder="Add Tags" v-model="formData.tags">
                  <vs-chip
                    class="glow-effect_primary"
                    :key="chip"
                    @click="removeTag(chip)"
                    v-for="chip in formData.tags"
                    closable>
                    {{ chip }}
                  </vs-chip>
                </vs-chips>
              </div>

            <vs-divider class="mb-6 pt-0">Video Cover Image</vs-divider>
              <div v-show="!isReadOnly" class="vx-col w-1/3 mx-auto  self-center">
                <file-pond
                    v-show="true"
                    id="cover-filepond"
                    allowPaste=false
                    ref="coverPagePond"
                    :server="uploadLocation"
                    label-idle="Drop Cover Image file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
                    accepted-file-types="image/*"
                    :allow-multiple="false"
                    :instant-upload="true"
                    @processfile="uploadCompleteCover"
                    @removefile="fileRemovedCover"
                  />
              </div>

            <div class="vx-row ">
              <div class="vx-col sm:w-2/3 w-full mb-2 mx-auto">
                <div v-show="formData.id">
                  <vs-table ref="coverPageUploadTable" single max-items="5" :data="uploadedCoverpageFile">
                    <template slot-scope="{data}">
                      <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
                        <vs-td style="width: 40px">
                          <img :src="file.coverPageUrl" width=30px class="product-img" />
                        </vs-td>                 
                        <vs-td>
                          <p class="product-name font-medium">{{ file.title }}</p>                     
                        </vs-td>
                        <vs-td>
                          <vs-button v-show="!isReadOnly" color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="clearCoverPageUrl"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>                      
              </div>
            </div>  

            <vs-divider class="mb-6 pt-0">Video upload</vs-divider>
              <div v-show="!isReadOnly" class="vx-col w-1/3 mx-auto  self-center">
                <file-pond
                    v-show="true"
                    id="video-filepond"
                    ref="VideoUploadPond"
                    allowPaste=false
                    :server="uploadLocation"
                    label-idle="Drop MP4 file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
                    accepted-file-types="video/mp4"
                    :allow-multiple="false"
                    :instant-upload="true"
                    @processfile="uploadCompleteVideo"
                    @removefile="fileRemovedVideo"              
                  />           
              </div>

            <div class="vx-row  ">
              <div class="vx-col sm:w-2/3 w-full mb-2 mx-auto">
                <div v-show="formData.id">
                  <vs-table ref="videoUploadTable" single max-items="5" :data="uploadedVideoFile">
                    <template slot-scope="{data}">
                      <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data"> 
                        <vs-td>
                          <p class="product-name font-medium">{{ file.videoUrl}}</p>
                        </vs-td>                                    
                        <vs-td>
                          <p class="product-name font-medium">{{ file.producer}} </p>
                        </vs-td>                      
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>                      
              </div>
            </div>

            <subjects-view 
              :isCardActive="isSubjectsViewActive"
              :libraryResourceId="formData.id"
              :resourceType="'Video'"
            />
            
            <vs-divider class="mb-6 pt-0"></vs-divider>
            
            <div v-if="!isReadOnly" class="vx-row">
              <vs-spacer></vs-spacer>
              <div class="vx-col flex">
                <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color mr-3">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="CheckIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      color="success"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_success vs-con-loading__container"
                      style="border-radius:0 7px 7px 0;"
                      ref="saveEditButton"
                      @click="saveEditVideo">
                      Save
                    </vs-button>
                  </vx-input-group>
                </vx-card>
                <vx-card v-show="formData.id" class="mb-4 glow-effect_dark card__no-padding bg-color mr-3">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="Trash2Icon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_danger vs-con-loading__container"
                      color="danger"
                      style="border-radius:0 7px 7px 0;"
                      ref="deleteButton"
                      @click="deleteVideo">
                      Delete
                    </vs-button>
                  </vx-input-group>
                </vx-card>          
                <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="XIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_warning "
                      color="warning"
                      style="border-radius:0 7px 7px 0;"
                      @click="cancelAdd">
                      Cancel
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
            </div>
            <div v-else class="vx-row">
              <vs-spacer></vs-spacer>
              <div class="vx-col flex">      
                <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                        <span><feather-icon class="pt-2" icon="XIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_success vs-con-loading__container"
                      color="success"
                      style="border-radius:0 7px 7px 0;"
                      @click="cancelAdd">
                      Close
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
            </div>
          </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  import SubjectsView from './Components/Subjects.vue'

  export default {
    components: {
      'v-select': vSelect,
      FilePond,
      SubjectsView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      genres: {
        type: Array
      }
    },
    data() {
      return {
        isSubjectsViewActive: false,
        isVideoListHidden: false,        
        pageSize: 10,        
        videos: [],        
        isInfoHidden: true,
        formData: {
          id: 0,
          title: "",
          producer: "",
          coverPageUrl: null,
          url: "",
          genreId: 0,
          summary: "",
          tags: [],
          genreName: ""
        },         
        genreDropdown: 0,       
        uploadedCoverpageFile: [],         
        uploadedVideoFile: [],
        isReadOnly: false
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }        
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {      
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.loadVideoData();
        }
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.title = "";
        this.formData.producer = "";
        this.formData.coverPageUrl = "";
        this.formData.url = "";
        this.formData.genreId = 0;
        this.formData.summary = "";
        this.formData.uploadedFileName = "";
        this.formData.genreName = "";
        this.errors.clear();
        this.genreDropdown = null;       
        this.formData.tags = [];
        this.uploadedVideoFile = [];
        this.uploadedCoverpageFile = [];
        this.$refs.coverPagePond.removeFiles();
        this.$refs.VideoUploadPond.removeFiles();
        this.isSubjectsViewActive = true;
        this.isReadOnly = false;
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
        this.isVideoListHidden = false;
        this.isSubjectsViewActive = false;
        this.$emit("showBackButton");
      },      
      addNewVideo() {
        this.initValues();
        this.isVideoListHidden = true;
        this.isInfoHidden = false;
        this.isSubjectsViewActive = false;
        this.$emit("hideBackButton");
      },
      handleSelectedVideo(video) {
        this.$emit("hideBackButton");
        this.isVideoListHidden = true;
        this.isInfoHidden = false;
        this.isReadOnly = video.isReadOnly ? true : false;
        this.formData.id = video.id;
        this.formData.title =  video.title;    
        this.formData.producer = video.producer;
        this.formData.coverPageUrl = video.coverPageUrl;
        this.formData.url = video.url;
        this.formData.genreId = video.genreId;
        this.formData.summary = video.summary;
        this.formData.tags = video.tags;
        this.formData.genreName = video.genreName;

        this.isSubjectsViewActive = true;
        
        this.genreDropdown = this.genres.filter(function(item){return item.value == video.genreId; })[0];       

        this.uploadedCoverpageFile.push({
          title: video.title,
          producer: video.producer,
          coverPageUrl: video.coverPageUrl
        })

        this.uploadedVideoFile.push({
          videoUrl: video.title,
          producer: video.producer       
        })

        this.$refs.coverPagePond.removeFiles();
        this.$refs.VideoUploadPond.removeFiles();
      },
      loadVideoData() {
        var self = this;
        self.showLoadingOnElement("videoTable", 1, "material");

        var onSuccess = function (response) {
          self.videos = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.videoTable.$el);
        };

        self.$ajaxGet(self, "LibraryResource/ListVideos", onSuccess, onFinally);
      },
      saveEditVideo() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            if(self.formData.coverPageUrl){
              self.showLoadingOnElement("saveEditButton", 0.45, "material");
              self.formData.genreId = self.genreDropdown ? parseInt(self.genreDropdown.value) : null;

              var onSuccess = response => {
                self.uploadedVideoFile = [];
                self.uploadedCoverpageFile = [];
                self.isInfoHidden = true;
                self.isVideoListHidden = false;
                self.$emit("showBackButton");
                self.$vs.notify({
                  title:'Information',
                  color: "success",
                  text: "Video Saved",
                  position:'top-right',
                  iconPack: 'feather',
                  icon:'icon-save'
                });
                self.loadVideoData()
              };

              this.isSubjectsViewActive = false;
              var onFinally = function () {
                self.$vs.loading.close(self.$refs.saveEditButton.$el);
              };

              self.$ajaxPost(self, "LibraryResource/AddEditVideo", self.formData, onSuccess, onFinally);
            }
            else{
              self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: "Video Cover Image Required",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
              });
            }
          }
          else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteVideo(){
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");
        var onSuccess = response => {
          self.uploadedVideoFile = [];
          self.uploadedCoverpageFile = [];
          self.isInfoHidden = true;
          self.isVideoListHidden = false;
          self.$emit("showBackButton");
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Video Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash-2'
          });
          self.loadVideoData()
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxGet(self, "LibraryResource/Delete/" + self.formData.id, onSuccess, onFinally); 
      },
      uploadCompleteVideo(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url){
          this.uploadedVideoFile = [];
          this.formData.url = response.url;
          this.uploadedVideoFile.push({
            videoUrl: file.filename,   
          })
        }
      },
      fileRemovedVideo(error, file) {
        this.formData.url = "";
      },
      uploadCompleteCover(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.formData.coverPageUrl = response.url;
      },
      fileRemovedCover(error, file) {
        this.formData.coverPageUrl = "";
      },
      clearCoverPageUrl() {
        this.uploadedCoverpageFile = [];
        this.formData.coverPageUrl = "";
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      removeTag(tagItem) {
        this.formData.tags.splice(this.formData.tags.indexOf(tagItem), 1)
      },
      addTag(){
          this.formData.tags.push(this.tagToAdd);
          this.tagToAdd = ""; 
      }
    }
  }

</script>

<style lang="scss">
  #studentComment {
    box-shadow: 0 4px 20px 0 rgba(var(--vs-danger),0.3);
  }
</style>
